export const URL_TARJETAS_DASHBOARD =
  "/Cxc/WebService/CxcWebService.asmx/buscarTarjetasDashboard";
export const URL_TOP10_DASHBOARD =
  "/Cxc/WebService/CxcWebService.asmx/buscarTop10Dashboard";
export const URL_CLIENTES_AUTOCOMPLETE =
  "/Cxc/WebService/CxcWebService.asmx/BuscarListadoClientes";
export const URL_CLIENTES_GRID_DASHBOARD =
  "/Cxc/WebService/CxcWebService.asmx/buscarClientesGrid";
  
